import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from 'src/core/http/api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MessageService {
  private endPointBaseurl: string;

  constructor(
    private apiService: ApiService) {
      this.endPointBaseurl = environment.appApiUrl;
    }


  public getInboxMessages(startIndex = 0, pageSize = 40, sortingName = 'Date', sortingDirection = 'desc'): Observable<any> {
    const searchParams = new HttpParams()
    .set('startIndex', startIndex.toString())
    .set('pageSize', pageSize.toString())
    .set('sortingName', sortingName)
    .set('sortingDirection', sortingDirection)
    .set('readYN', null);

    return this.apiService.Get('message/inbox', searchParams);
  }


  public getSentMessages(startIndex = 0, pageSize = 40, sortingName = 'Date', sortingDirection = 'desc'): Observable<any> {
    const searchParams = new HttpParams()
    .set('startIndex', startIndex.toString())
    .set('pageSize', pageSize.toString())
    .set('sortingName', sortingName)
    .set('sortingDirection', sortingDirection);

    return this.apiService.Get('message/sent', searchParams);
  }


  public getArchivedMessages(startIndex = 0, pageSize = 40, sortingName = 'Date', sortingDirection = 'desc'): Observable<any> {
    const searchParams = new HttpParams()
    .set('startIndex', startIndex.toString())
    .set('pageSize', pageSize.toString())
    .set('sortingName', sortingName)
    .set('sortingDirection', sortingDirection);

    return this.apiService.Get('message/archive', searchParams);
  }


  public markMessageAsRead(guid): Observable<any> {
    const searchParams = new HttpParams()
    .set('id', guid.toString());

    return this.apiService.Put('message', searchParams, null);
  }


  public markMessageAsArchived(guid, fromFolder): Observable<any> {
    const searchParams = new HttpParams()
    .set('fromFolder', fromFolder)
    .set('id', guid.toString());

    return this.apiService.Delete('message/archive', searchParams);
  }


  public postMessage(message: any): Observable<any> {
    return this.apiService.Post('message', message);
  }


  public uploadAttachment(formData: FormData): Observable<any> {
    return this.apiService.Upload('message/attachment', formData);
  }


}
